import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Navigationskomponente für die Anwendung
 * @returns {JSX.Element} Navigation
 */
const Navigation = () => {
  const location = useLocation();
  
  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="text-xl font-semibold">
                <span className="text-blue-500">Sunny</span> Ride
              </span>
              <span className="ml-2">
                <span role="img" aria-label="bicycle" className="text-xl">🚲</span>
              </span>
            </Link>
          </div>
          
          <div className="flex space-x-4">
            <NavLink to="/" active={location.pathname === "/"}>
              Home
            </NavLink>
            <NavLink to="/score" active={location.pathname === "/score"}>
              SunnyScore™
            </NavLink>
          </div>
        </div>
      </div>
    </nav>
  );
};

/**
 * NavLink Komponente für die Navigation
 */
const NavLink = ({ children, to, active }) => {
  return (
    <Link
      to={to}
      className={`px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 ${
        active
          ? 'bg-blue-100 text-blue-600'
          : 'text-gray-700 hover:bg-blue-50 hover:text-blue-500'
      }`}
    >
      {children}
    </Link>
  );
};

export default Navigation;